import { ChangeDetectorRef, Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { GlobalMessageType } from '@spartacus/core'
import { switchMap, take } from 'rxjs/operators'
import { DispenserCreditClaimDetailStatus } from '../../../../../models/enum/dispenser.enum'
import { ICsv } from '../../../../../models/interface/csv.interface'
import { DispenserAgreementService } from '../../../../../services/agreement/dispenser/dispenser-agreement.service'
import { DispenserShipmentService } from '../../../../../services/agreement/dispenser/dispenser-shipment.service'
import { ShipmentCreditClaimService } from '../../../../../services/agreement/shipment-credit-claim/shipment-credit-claim.service'
import { CsvService } from '../../../../../services/shared/csv/csv.service'
import { CustomGlobalMessageService } from '../../../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../../../services/shared/shared.service'
import { ICustomSelectOption } from '../../../../shared/custom-components/custom-select/modals/interface/custom-select.interface'
import { CustomTableColumnType } from '../../../../shared/custom-components/custom-table/modals/enum/custom-table.enum'
import { DispenserShipmentDetailComponent } from '../../dispenser-agreement/dispenser-shipment/dispenser-shipment-detail/dispenser-shipment-detail.component'

@Component({
    selector: 'app-shipment-credit-claims-detail',
    templateUrl: './shipment-credit-claims-detail.component.html',
    styleUrls: ['./shipment-credit-claims-detail.component.scss'],
    standalone: false
})
export class ShipmentCreditClaimsDetailComponent extends DispenserShipmentDetailComponent {
  public dispenserShipmentId: string
  public filterOptions: ICustomSelectOption[] = Object.keys(DispenserCreditClaimDetailStatus).map((item) => {
    return {
      label: 'dispenserShipment.status.' + item,
      value: item
    }
  })

  constructor(
    dispenserAgreementService: DispenserAgreementService,
    dispenserShipmentService: DispenserShipmentService,
    globalMessageService: CustomGlobalMessageService,
    sharedService: SharedService,
    changeDetectorRef: ChangeDetectorRef,
    route: ActivatedRoute,
    csvService: CsvService,
    private shipmentCreditClaimService: ShipmentCreditClaimService
  ) {
    super(
      dispenserAgreementService,
      dispenserShipmentService,
      globalMessageService,
      sharedService,
      changeDetectorRef,
      route,
      csvService
    )
  }

  ngOnInit(): void {
    // remove last 4 columns
    this.headers.splice(4, 4)
    this.headers.push({ title: 'dispenserShipment.netValue' })
    this.headers.push({ title: 'dispenserShipment.gst' })
    this.headers.push({ title: 'dispenserAgreement.invoiceNumber' })

    this.columns = [
      { key: 'product.code' },
      { key: 'product.name' },
      { key: 'shipmentEntryStatus' },
      { key: 'namedDeliveryDate', type: CustomTableColumnType.DATE },
      { key: 'netValue.formattedValue' },
      { key: 'gst.formattedValue' },
      { key: 'invoiceNumber' }
    ]

    this.route.queryParamMap
      .pipe(
        switchMap((params) => {
          this.dispenserShipmentId = params.get('dispenserShipmentId')
          this.agreementId = params.get('agreementId')
          this.shipmentId = params.get('shipmentId')
          return this.shipmentCreditClaimService.getShipmentCreditClaimById(this.dispenserShipmentId)
        }),
        switchMap((detail) => {
          if (detail.entries?.length) {
            this.shipment = detail.entries.find((item) => item.code == this.shipmentId)
            this.changeDetectorRef.detectChanges()
          }
          return this.dispenserShipmentService.getShipmentEntries(this.agreementId, this.shipmentId)
        }),
        take(1)
      )
      .subscribe((entries) => {
        this.entries = entries
        this.entries.results = this.changeEntriesStatus(entries.results)
        this.showInitialLoader = false
        this.changeDetectorRef.detectChanges()
      })
  }

  downloadCSV(): void {
    this.downloadingCsv = true
    this.dispenserShipmentService.downloadCSVEntries(this.agreementId, this.shipmentId).subscribe(
      (results) => {
        const csv: ICsv = {
          title: `Credit Entries`,
          columns: [
            { title: 'dispenserAgreement.materialNumber', key: 'product.code' },
            { title: 'dispenserAgreement.materialDescription', key: 'product.name' },
            { title: 'shared.status', key: 'shipmentEntryStatus' },
            { title: 'dispenserShipment.eta', key: 'namedDeliveryDate', type: CustomTableColumnType.DATE },
            { title: 'dispenserShipment.netValue', key: 'netValue.formattedValue' },
            { title: 'dispenserShipment.gst', key: 'gst.formattedValue' },
            { title: 'dispenserAgreement.invoiceNumber', key: 'invoiceNumber' }
          ],
          rows: this.changeEntriesStatus(results)
        }
        this.downloadingCsv = false
        this.csvService.generateCSV(csv)
        this.changeDetectorRef.detectChanges()
      },
      (err) => {
        this.downloadingCsv = false
        this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        this.changeDetectorRef.detectChanges()
      }
    )
  }
}
